import { render, staticRenderFns } from "./BgmCreditSnack.vue?vue&type=template&id=59da3a82&scoped=true&"
import script from "./BgmCreditSnack.vue?vue&type=script&lang=ts&"
export * from "./BgmCreditSnack.vue?vue&type=script&lang=ts&"
import style0 from "./BgmCreditSnack.vue?vue&type=style&index=0&id=59da3a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59da3a82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VIcon,VListItem,VListItemContent,VListItemSubtitle,VSnackbar})
